import type { ReactNode } from 'react'
import { ChevronRight } from 'lucide-react'
import { SectionHeader } from '../../components/SectionHeader'
import { SettingsCard, SettingsRow } from '../../components/SettingsCard'

export function SettingsSection({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <section>
      <SectionHeader variant="settings">{title}</SectionHeader>
      <SettingsCard>{children}</SettingsCard>
    </section>
  )
}

/** A Settings row that opens another screen: chevron on the right, optional badge before it. */
export function SettingsLinkRow({
  icon,
  label,
  onClick,
  badge,
  testId,
}: {
  icon?: ReactNode
  label: ReactNode
  onClick: () => void
  badge?: ReactNode
  testId?: string
}) {
  return (
    <SettingsRow
      icon={icon}
      label={label}
      trailing={
        <span className="inline-flex items-center gap-2">
          {badge}
          <ChevronRight className="size-4 text-muted-foreground" />
        </span>
      }
      onClick={onClick}
      buttonProps={testId ? { 'data-testid': testId } : undefined}
    />
  )
}
